<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 flex justify-between mb-6">
      <span class="text-[#2d82b5] font-semibold">
        SBAC for {{ info.fullName }}
      </span>
      <span class="text-sm">
        {{ $t("common.student_id") }}:
        <span class="font-semibold">{{ info.studentCode }}</span>
        <span class="ml-4">
          {{ $t("common.grade") }}:
          <span class="font-semibold">{{ info.grade }}</span>
        </span>
      </span>
    </div>

    <div class="md-layout-item md-size-100">
      <p class="font-medium mb-3">
        {{ $t("smi_sri.detail_about_tests") }}
      </p>

      <md-table class="table-pdf-assessment">
        <md-table-row>
          <md-table-cell>{{ $t("common.grade") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.assessment_name") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.score_result") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.achievement_level") }}</md-table-cell>
          <md-table-cell>{{
            $t("smi_sri.level_or_proficiency")
          }}</md-table-cell>
          <md-table-cell>{{
            $t("smi_sri.assessment_family_achievement_level")
          }}</md-table-cell>
          <md-table-cell>{{
            $t("smi_sri.assessment_school_year")
          }}</md-table-cell>
        </md-table-row>

        <md-table-row v-for="(row, index) in dataTable" :key="'ACT' + index">
          <md-table-cell class="text-center">{{ row.grade }}</md-table-cell>
          <md-table-cell class="text-center">{{
            row.assessmentName
          }}</md-table-cell>
          <md-table-cell class="text-center">{{
            row.scoreResult
          }}</md-table-cell>
          <md-table-cell class="text-center">{{
            row.achievementLevel
          }}</md-table-cell>
          <md-table-cell class="text-center">{{
            row.levelOrProficiency
          }}</md-table-cell>
          <md-table-cell class="text-center">{{
            row.assessmentFamilyAchievementLevel
          }}</md-table-cell>
          <md-table-cell class="text-center">{{
            row.assessmentSchoolYear
          }}</md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
export default {
  name: "export-pdf-sbac",
  props: ["info", "dataTable"]
};
</script>
<style lang="scss" scoped></style>
